import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge class names — Shadcn/ui-style cn() utility.
 * clsx resolves conditional classes; tailwind-merge dedupes conflicting
 * Tailwind utilities so the last one wins (e.g. `p-2 p-4` → `p-4`).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Deep-links to a different agent in a new tab instead of an in-SPA
 * `navigate()` — a same-tab navigation would unmount the current agent's
 * in-progress session state (unsaved mapping/profiling/etc. work).
 */
export function openAgentInNewTab(path: string) {
  window.open(path, "_blank", "noopener,noreferrer");
}
